import { useAnalytics } from '@townsquare/analytics';
import { getModifiedShortcut, useKeyboardShortcut } from '@townsquare/keyboard-shortcuts';
import { GO_FOR_YOU_SHORTCUT, GO_TEAMS_PAGE_SHORTCUT } from '@townsquare/keyboard-shortcuts/constants';
import { useKeyboardShortcutStore } from '@townsquare/keyboard-shortcuts/store';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { staffDirectoryRoute } from '@townsquare/routes/staff-directory-view';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';
import { teamsDirectoryRoute } from '@townsquare/routes/teams-directory-view';
import { fg } from '@townsquare/stat-sig/gate';

export const useKeyboardShortcuts = (): void => {
	const analytics = useAnalytics();
	const { pushTo } = useRouterActions();
	const [{ type }] = useKeyboardShortcutStore();

	const handleGoToKeypress = (_e: KeyboardEvent, keypress: string | undefined) => {
		switch (keypress) {
			case getModifiedShortcut(type, GO_FOR_YOU_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goHomePageShortcut');
				void pushTo(fg('migrate-staff-directory-route-refs') ? teamsAppForYouRoute : staffDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_TEAMS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goTeamsPageShortcut');
				void pushTo(fg('migrate-staff-directory-route-refs') ? teamsDirectoryRoute : staffDirectoryRoute, {
					query: { screen: 'SEARCH_TEAMS' },
				});
				break;
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_FOR_YOU_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_TEAMS_PAGE_SHORTCUT, handleGoToKeypress);
};
